export enum HELP_DRAWER {
  COST_TABLES = 'costTablesHelp',
}

const HELP_URLS: Record<HELP_DRAWER, string> = {
  [HELP_DRAWER.COST_TABLES]:
    'https://help.autodesk.com/view/INF360A/ENU/?guid=GUID-B7D9B195-6BCF-4033-AA70-CFC2B94BCDBB',
};

export const getHelpURL = (type: HELP_DRAWER): string =>
  HELP_URLS[type] ?? 'https://help.autodesk.com';
